import {BaseTerms} from "../../infrastructure/models/base-terms";

export class PropositionBetsWidgetTerms extends BaseTerms {

}
